<template>
  <MTooltip placement="top">
    <template v-slot:trigger>
      <a href="javascript:;" v-on="$listeners">
        <MIcon name="pencil" />
      </a>
    </template>
    {{ $t('edit') }}
  </MTooltip>
</template>

<script>
export default {
  name: 'ControlEditButton',
}
</script>
